import { PersonChangesInfo } from '@aibees/elephant/feature/search-table-people';
import { HttpMethod } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { useCallback } from 'react';
import { COMPANY_READ_API_CHANGES } from '../../constants';
import { ReadPersonRequest } from '../types';

let globalDebounceTimeout: NodeJS.Timeout | null = null;

export function useReadCompanyChanges(id?: string) {
  const workspaceId = useWorkspace()?.id;

  const api = useBaseQuery<ReadPersonRequest, PersonChangesInfo>(
    [useReadCompanyChanges.name, id],
    {
      url: COMPANY_READ_API_CHANGES.replace(
        ':wid',
        String(workspaceId)
      ).replace(':id', String(id)),
      method: HttpMethod.get,
      headers: { 'x-customer-id': workspaceId },
    },
    {
      enabled: false,
    }
  );

  const debouncedRefetch = useCallback(() => {
    if (!id) return;
    if (globalDebounceTimeout) {
      clearTimeout(globalDebounceTimeout);
    }
    globalDebounceTimeout = setTimeout(() => {
      api.refetch();
      globalDebounceTimeout = null;
    }, 1000); // Adjust the delay as needed.
  }, [api, id]);

  return { ...api, debouncedRefetch };
}
